import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./BadgeCounter.module.css";
import clsx from "clsx";
export const BadgeCounter = ({ number, children, layoutClassName, }) => (_jsxs("div", { className: styles.content, children: [children, _jsx("span", { className: clsx([layoutClassName && layoutClassName], styles.badge), children: number })] }));
